<template>
  <div v-if="this.activeLeague.Promo === false" class="d-flex flex-column align-items-center pt-1 pb-2">
    <div class="d-flex flex-column justify-content-center align-items-center col-4 secondary-bg-colour primary-text games-to-play-container">
      {{ formatString('league_bar_games_to_play_count_text', [this.gamesToPlay]) }}
    </div>
    <div @click="leagueBarClicked(this.activeLeague)" class="d-flex flex-row justify-content-center league-container pt-4">
      <div class="d-flex flex-column text-center justify-content-center win-data primary-bg-colour col-2">
        <img class="win-data-img" :src="require(`../brand/${this.brandConfig}/assets/win-data-amount-icon.png`)">
      </div>
      <div class="d-flex flex-row text-center align-items-center league-title secondary-bg-colour primary-text col-8">
        <img class="league-icon-img" :src="this.findImageModule(this.activeLeague.LeagueName)">
        <div class="col-9 sport-text">{{ this.activeLeague.LeagueName }}</div>
      </div>
      <div class="predict-button primary-text col-2">
        {{ formatString('league_bar_predict_text') }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {translationsFormatter} from "@/functions/translationsFormatter";
import PredictorService from "@/services/predictorService";
import {environmentConfig} from "@/config/enviromentConfig";
import UpstreamService from "@/services/upstreamService";

export default {
  name: "LeagueBar",
  inheritAttrs: false,
  props: ['activeLeague'],
  data() {
    return {
      gamesToPlay: 0,
    }
  },
  async beforeMount() {
    await this.countFixturesInRound()
  },
  computed: {
    ...mapState(['brandConfig', 'user']),
  },
  methods: {
    ...mapMutations(['setSelectedSportLeague']),
    formatString(string, ...placeholders) {
      return translationsFormatter(string, ...placeholders)
    },
    leagueBarClicked(leagueFixture) {
      this.setSelectedSportLeague(leagueFixture.LeagueAbbreviation)
      this.$router.push({name: `MakePredictions${leagueFixture.SportName}`, params: {roundId: leagueFixture.RoundID}});
    },
    findImageModule(teamName) {
      let teamNameReformat = teamName.split(" ").join("-").toLowerCase()
      try {
        return [require(`../assets/leagueLogos/${teamNameReformat}-logo-default.png`)]
      } catch (e) {
        return [require(`../assets/game/default-badge.png`)]
      }
    },
    async countFixturesInRound() {
      let fixturesResponse = await PredictorService.getLeagueFixtures(`${this.user.msisdn}`, `${this.activeLeague.RoundID}`)
      this.gamesToPlay = fixturesResponse.data.fixtures.length
    }
  },
  watch: {
    async $route(to, from) {
      let fixturesResponse = await PredictorService.getLeagueFixtures(`${this.user.msisdn}`, `${this.activeLeague.RoundID}`)
      this.gamesToPlay = fixturesResponse.data.fixtures.length
    }
  }
}
</script>

<style scoped>
.league-container {
  display: flex;
  justify-content: center;
  width: 108%;
  position: relative;
}

.games-to-play-container {
  height: 16px;
  border-radius: 10px 10px 0 0;
  font-size: 10px;
  font-weight: 400;
  margin-bottom: -23px;
}

.win-data {
  position: relative;
  height: 55px;
  border-radius: 25%;
  z-index: 2;
}

.win-data-img {
  margin-bottom: 5px;
  left: 3px;
  position: absolute;
  width: 100%;
}

.league-title {
  position: relative;
  height: 55px;
  margin-left: -20px;
  border-radius: 0 15px 15px 0;
  z-index: 1;
}

.sport-text {
  padding-left: 30%;
  font-weight: 700;
  font-size: 12px;
}

.predict-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
  background-color: #019601;
  writing-mode: vertical-lr;
  margin-left: -20px;
  z-index: 0;
  border-radius: 15px 0 0 15px;
  -webkit-transform: rotate(-180deg);
}

.tbc-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
  background-color: #adadad;
  writing-mode: vertical-lr;
  margin-left: -20px;
  z-index: 0;
  border-radius: 15px 0 0 15px;
  -webkit-transform: rotate(-180deg);
}

.league-icon-img {
  position: absolute;
  left: 25px;
  height: 35px;
}

</style>
